export const en = {
    'default-error': 'Something went wrong with the banner',
    'new-banner': 'New ad',
    'wrong-place-id': 'The campaign has an invalid Place Id'
};
